import { useMemo } from 'react'
import { useAppSelector } from '@store/hooks'
import { IClinic } from '@dataTypes/clinic.type'

/** Clinics configured for the practice, limited to the staff member's assigned locations. */
export const usePracticeClinics = (): IClinic[] => {
  const clinicData = useAppSelector((state) => state.clinic.data)
  const staffAssignedClinicIds = useAppSelector(
    (state) => state.clinic.staffAssignedClinicIds,
  )

  return useMemo(() => {
    const visible = clinicData.filter((clinic) => !clinic.is_hidden)
    if (staffAssignedClinicIds === null) return visible
    const allowed = new Set(staffAssignedClinicIds)
    return visible.filter((clinic) => allowed.has(clinic.clinic_id))
  }, [clinicData, staffAssignedClinicIds])
}
